/**
 * User: Rob
 * Date: 8/20/13
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel.js');
var Disbursement = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Disbursement = Disbursement;

var Backbone = require('dibs-backbone');
var _ = require('underscore');
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethod');
var endpoints = require('dibs-endpoints');
var Party = require('bunsen/models/Party');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');

_.extend(Disbursement, {
    STATUS_NEW: 'NEW',
    STATUS_PAID: 'PAID'
});

_.extend(Disbursement.prototype, {
    idAttribute: "id",
    defaults: {
        paymentMethod: {}
    },
    url : function () {
        return endpoints.disbursement(this.get(this.idAttribute));
    },
    relations: [
        {
            key: 'paymentMethod',
            relatedModel: PaymentMethod,
            type: Backbone.One,
            saveJSONFields: ['paymentMethodType', 'apiType']
        },
        {
            key: 'payTo',
            relatedModel: Party,
            type: Backbone.One
        },
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        }
    ],
    isDealerDisbursement: function () {
        return this.get('payTo').isSeller();
    },
    isShipperDisbursement: function () {
        return this.get('payTo').isShipper();
    },
    isPaid: function () {
        return this.get('status') === Disbursement.STATUS_PAID;
    },
    isNewStatus: function () {
        return this.get('status') === Disbursement.STATUS_NEW;
    }
}, transitionMixin);


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Disbursement.js
// module id = 171
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54